import React, { useContext, useEffect } from "react";
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SideMenuContent from './SideMenuContent';
import UserOptionsMenu from './UserOptionsMenu';
import AuthContext from "../context/AuthContext";
import { blue } from "@mui/material/colors"; // #POW-26

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

export default function SideMenu() {
  const auth = useContext(AuthContext)
  const { isReady } = useContext(AuthContext)
 

  useEffect(() => {
    if (isReady) {
    }
  }, [isReady]);
  
  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column', alignItems: 'center',
          mt: 'calc(var(--template-frame-height, 0px) + 4px)',
          p: 1.5,
          }}
          >
            <Box sx={{ backgroundColor: '#E51B14', width: '100%', textAlign: 'center', paddingTop: '5px' }}> {/* #POW-5 */}
              <img src="logo-worten.svg" alt="Worten logo" style={{ width: '80%', minWidth: '150px', height: 'auto'}} />
            </Box>
            <Box sx={{ width: '100%', textAlign: 'center'}}> {/* #POW-5 */}
              <img src="logo-picea.svg" alt="Picea logo" style={{ width: '80%', minWidth: '150px', height: 'auto'}} />
            </Box>
      </Box>
      <Divider />

      <SideMenuContent role={auth.user?.entitlement ?? ''}/> {/* #POW-20 */}

      {/* ------ BOTTOM --- User Area */}
      <Stack
        direction="row"
        sx={{
          p: 2,
          gap: 1,
          alignItems: 'center',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        
        <Avatar sizes="small"
          sx={{ width: 36, height: 36, bgcolor: blue[900] }} >{auth.user?.avatar}</Avatar> {/* #POW-26 */}
        <Box sx={{ mr: 'auto' }}>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
            {auth.user?.fullName} {/* #POW-5 */}
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {auth.user?.jobTitle} {/* #POW-5 */}
          </Typography>
        </Box>
        <UserOptionsMenu user={auth.user}/>
      </Stack>
    </Drawer>
  );
}
